import { useEffect, useState } from "react";
import { SmartUpgradeModal } from "../SmartUpgradeModal/SmartUpgradeModal";

interface LimitDetail {
  resourceType: string;
  current?: number;
  limit?: number;
}

/**
 * Prompt global de límite de plan (spec 007, US2 / FR-011).
 * Vive siempre montado en MenuWrapper y escucha el evento global
 * "plan-limit-reached" (payload `{resourceType, current, limit}`) que disparan
 * los interceptores de axios al recibir code=PLAN_LIMIT_REACHED y los flujos
 * que crean recursos con cupo (cajas, almacenes, usuarios, sedes). Abre el
 * SmartUpgradeModal: comprar el adicional o subir de plan.
 */
const PlanLimitPrompt = () => {
  const [detail, setDetail] = useState<LimitDetail | null>(null);

  useEffect(() => {
    const onLimit = (e: Event) => {
      const d = (e as CustomEvent).detail;
      if (d?.resourceType) {
        setDetail({
          resourceType: String(d.resourceType),
          current: typeof d.current === "number" ? d.current : undefined,
          limit: typeof d.limit === "number" ? d.limit : undefined,
        });
      }
    };
    window.addEventListener("plan-limit-reached", onLimit);
    return () => window.removeEventListener("plan-limit-reached", onLimit);
  }, []);

  if (!detail) return null;

  return (
    <SmartUpgradeModal
      isOpen
      extraType={detail.resourceType}
      current={detail.current}
      limit={detail.limit}
      onClose={() => setDetail(null)}
    />
  );
};

export default PlanLimitPrompt;
